import InsightsTopicFilterInsights from './InsightsTopicFilterInsights';

export { type InsightsTopicFilterInsightsProps } from './InsightsTopicFilterInsights';
export default InsightsTopicFilterInsights;
